import { createStyles, makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function (theme) {
  return createStyles({
    root: {
      display: 'flex',
      flexDirection: function flexDirection(props) {
        return (props == null ? void 0 : props.direction) === 'vertical' ? 'column' : 'row';
      },
      '& > *': {
        marginRight: function marginRight(props) {
          return (props == null ? void 0 : props.direction) === 'vertical' ? 0 : (props == null ? void 0 : props.spaceWidth) || theme.spacing(1);
        },
        marginBottom: function marginBottom(props) {
          return (props == null ? void 0 : props.direction) === 'vertical' ? (props == null ? void 0 : props.spaceHeight) || theme.spacing(1) : 0;
        }
      },
      '& > *:last-child': {
        marginRight: 0,
        marginBottom: 0
      }
    }
  });
});
export default useStyles;